export default __webpack_public_path__ + "static/media/single-chip.26ec0ded.svg";